import { render, staticRenderFns } from "./PaxExpress.vue?vue&type=template&id=61b49cdb&"
import script from "./PaxExpress.vue?vue&type=script&lang=js&"
export * from "./PaxExpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports